<div class="main-content" [ngClass]="alayticsService.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    *ngIf="isExpand"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="true"
    [zIndex]="3003"
  >
  </ngx-spinner>
  <div class="d-flex justify-content-between" *ngIf="isExpand">
    <div></div>

    <nb-card class="cursor-pointer classroom-details">
      <nb-card-body>
        <div class="d-flex justify-content-between">
          <div class="classroom-name-content text-left">
            <h5 class="classroom-name quicksand-bold-label">
              {{ classroom?.name }}
            </h5>

            <div class="classroom-subject quicksand-bold-label">
              {{ classroom?.subject | uppercase }}
            </div>
          </div>

          <div class="d-flex" style="margin-right: -5px">
            <div class="classroom-code text-center">
              {{ classroom?.code }}
            </div>
          </div>
        </div>
      </nb-card-body>
    </nb-card>

    <div class="text-right mb-3 expand-view btn-close-content">
      <button class="btn-close" (click)="closeDialog()">
        <nb-icon icon="collapse" class="icon-close-expand-view"></nb-icon>
      </button>
    </div>
  </div>

  <nb-tabset (changeTab)="onTabChange($event)" active="{{ setActiveAdd }}" #tabset>
    <nb-tab tabTitle="Upcoming" #upcoming>
      <ng-container *ngIf="selectedTab === 'upcoming'">
        <ng-container *ngTemplateOutlet="assignmentCards; context: { list: studentUpcomingAssignments }"></ng-container>
      </ng-container>
    </nb-tab>

    <nb-tab tabTitle="Submitted" #submitted>
      <ng-container *ngIf="selectedTab === 'submitted'">
        <ng-container
          *ngTemplateOutlet="assignmentCards; context: { list: studentSubmittedAssignments }"
        ></ng-container>
      </ng-container>
    </nb-tab>

    <nb-tab tabTitle="Missed" #missed>
      <ng-container *ngIf="selectedTab === 'missed'">
        <ng-container
          *ngTemplateOutlet="assignmentCards; context: { list: studentSubmittedAssignments }"
        ></ng-container>
      </ng-container>
    </nb-tab>
  </nb-tabset>
</div>

<!-- <ng-template #myModal l let-modal>
  <div
    class="add-classroom-modal personal-information-modal"
    [ngClass]="{
      'add-assingment-modal': isExpand,
      'dark-theme': analyticsService?.currentTheme === 'material-dark'
    }"
  >
    <div
      class="modal-header d-flex justify-content-between align-items-center w-100"
    >
      <div class="d-flex">
        <h6 class="add-clasroom-text quicksand-bold-label m-0">
          Assignment Report
        </h6>
      </div>

      <span
        class="icon-close-classroom-modal d-block cursor-pointer"
        (click)="modalService.dismissAll(modalRef)"
      >
        <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
      </span>
    </div>

    <div class="modal-body">
      <div class="text-right">
        <mat-form-field appearance="outline" class="ml-auto">
          <mat-label>Filter By Answers</mat-label>
          <mat-select
            name="type"
            (selectionChange)="filterStudentAnswer($event.value)"
            [(ngModel)]="currentStatus"
          >
            <mat-option class="quicksand-bold-label select-range" value="all">
              None
            </mat-option>
            <mat-option
              class="quicksand-bold-label select-range"
              value="correct"
            >
              Correct
            </mat-option>
            <mat-option
              class="quicksand-bold-label select-range"
              value="incorrect"
            >
              Incorrect
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div
        *ngIf="currentAssignmentEvaluation?.length === 0"
        class="text-center"
      >
        <img
          src="/assets/images/respond-edu.svg"
          alt="no-data-found"
          height="150"
          width="150"
        />
        <h6 class="quicksand-bold-label">No Assignment Report Found!</h6>
      </div>

      <nb-card
        *ngFor="let evaluation of currentAssignmentEvaluation"
        class="mt-2 {{
          evaluation?.correctness ? 'card-valid' : 'card-invalid'
        }}"
      >
        <nb-card-header
          class="quicksand-bold-label d-flex justify-content-between"
          >{{ evaluation?.assignment_questions[0]?.content }}
        </nb-card-header>
        <nb-card-body>
          <div class="form-group">
            <label class="quicksand-normal-label">Correct Answer :</label>
            <div class="quicksand-bold-label">
              {{ evaluation?.assignment_questions[0]?.answer }}
            </div>
          </div>
          <hr />
          <div class="form-group">
            <label class="quicksand-normal-label">Attempted Answer :</label>
            <div
              class="quicksand-bold-label {{
                evaluation?.user_answer === '' ? 'skipped-answer' : ''
              }}"
            >
              {{
                evaluation?.user_answer !== ''
                  ? evaluation?.user_answer
                  : 'Skipped'
              }}
            </div>
          </div>
        </nb-card-body>
        <nb-card-footer>
          <label class="quicksand-bold-label"> Total Time : </label>
          &nbsp;

          <label class="quicksand-bold-label">{{
            evaluation?.total_time
          }}</label>
        </nb-card-footer>
      </nb-card>
    </div>
  </div>
</ng-template> -->

<div
  class="overlay-modal-content modal fade"
  #viewAssignmentEvaluationModal
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div
      class="modal-content add-classroom-modal personal-information-modal"
      [ngClass]="{
        'add-assingment-modal': isExpand,
        'dark-theme': alayticsService?.currentTheme === 'material-dark'
      }"
    >
      <div class="modal-header d-flex justify-content-between align-items-center w-100">
        <div class="d-flex">
          <h6 class="add-clasroom-text quicksand-bold-label m-0">Assignment Report</h6>
        </div>

        <span class="icon-close-classroom-modal d-block cursor-pointer" (click)="closeModal();currentStatus = ''">
          <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
        </span>
      </div>

      <div class="modal-body">
        <div class="text-right">
          <mat-form-field appearance="outline" class="ml-auto">
            <mat-label>Filter By Answers</mat-label>
            <mat-select name="type" (selectionChange)="filterStudentAnswer($event.value)" [(ngModel)]="currentStatus">
              <mat-option class="quicksand-bold-label select-range" value="all"> None </mat-option>
              <mat-option class="quicksand-bold-label select-range" value="correct"> Correct </mat-option>
              <mat-option class="quicksand-bold-label select-range" value="incorrect"> Incorrect </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- show the assignment report for the missed section if selected assignment has questions added in it-->
        <div *ngIf="currentAssignmentEvaluation?.length === 0 && assignmentQuestions?.length > 0">
          <nb-card *ngFor="let question of assignmentQuestions" class="mt-2">
            <nb-card-header class="quicksand-bold-label d-flex justify-content-between"
              >{{ question?.content }}
            </nb-card-header>
            <nb-card-body>
              <div class="form-group">
                <label class="quicksand-normal-label">Correct Answer :</label>
                <div class="quicksand-bold-label" [mathjax]="question?.answer"></div>
              </div>
              <hr />
              <div class="form-group">
                <label class="quicksand-normal-label">Attempted Answer :</label>
                <div class="quicksand-bold-label">-</div>
              </div>
            </nb-card-body>
            <nb-card-footer>
              <label class="quicksand-bold-label"> Total Time : 0 </label>
            </nb-card-footer>
          </nb-card>
        </div>

        <!-- show the assignment report for the missed section if selected assignment has no question added in it-->

        <div *ngIf="currentAssignmentEvaluation?.length === 0 && assignmentQuestions?.length === 0" class="text-center">
          <img src="/assets/images/respond-edu.svg" alt="no-data-found" height="150" width="150" />
          <h6 class="quicksand-bold-label text-center">No Assignment Report Found!</h6>
        </div>

        <!-- otherwise show evaluation data -->
        <nb-card
          *ngFor="let evaluation of currentAssignmentEvaluation"
          class="mt-2 {{ evaluation?.correctness ? 'card-valid' : 'card-invalid' }}"
        >
          <nb-card-header class="quicksand-bold-label d-flex justify-content-between"
            >{{ evaluation?.assignment_questions[0]?.content }}
          </nb-card-header>
          <nb-card-body>
            <div class="form-group">
              <label class="quicksand-normal-label">Correct Answer :</label>
              <div class="quicksand-bold-label" [mathjax]="evaluation?.assignment_questions[0]?.answer"></div>
            </div>
            <hr />
            <div class="form-group">
              <label class="quicksand-normal-label">Attempted Answer :</label>
              <div class="quicksand-bold-label {{ evaluation?.user_answer === '' ? 'skipped-answer' : '' }}">
                {{ evaluation?.user_answer !== '' ? evaluation?.user_answer : 'Skipped' }}
              </div>
            </div>
          </nb-card-body>
          <nb-card-footer>
            <label class="quicksand-bold-label"> Total Time : </label>
            &nbsp;

            <label class="quicksand-bold-label">{{ evaluation?.total_time }}</label>
          </nb-card-footer>
        </nb-card>
      </div>
    </div>
  </div>
</div>

<!-- common card code -->
<ng-template #assignmentCards let-list="list">
  <ng-container *ngIf="!isExpand && studentUpcomingAssignments?.length > 0">
    <div
      class="pagination d-flex justify-content-end quicksand-bold-label mb-3"
      *ngIf="currentPage !== 1 || studentUpcomingAssignments?.length > 0"
    >
      <span class="quicksand-bold-label mt-2">{{ currentPage }} / {{ totalPages }}</span>
      <button
        class="btn-paginate mr-2 ml-2 quicksand-bold-label"
        (click)="currentPage = currentPage - 1; getAssignments()"
        [disabled]="currentPage === 1"
      >
        <nb-icon icon="arrow-back-outline"></nb-icon>
      </button>

      <button
        class="btn-paginate quicksand-bold-label"
        (click)="currentPage = currentPage + 1; getAssignments()"
        [disabled]="currentPage === totalPages"
      >
        <nb-icon icon="arrow-forward-outline"></nb-icon>
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="!isExpand && studentSubmittedAssignments?.length > 0">
    <div
      class="pagination d-flex justify-content-end quicksand-bold-label mb-3"
      *ngIf="currentPage !== 1 || studentSubmittedAssignments?.length > 0"
    >
      <span class="quicksand-bold-label mt-2">{{ currentPage }} / {{ totalPages }}</span>
      <button
        class="btn-paginate mr-2 ml-2 quicksand-bold-label"
        (click)="currentPage = currentPage - 1; getAssignments()"
        [disabled]="currentPage === 1"
      >
        <nb-icon icon="arrow-back-outline"></nb-icon>
      </button>

      <button
        class="btn-paginate quicksand-bold-label"
        (click)="currentPage = currentPage + 1; getAssignments()"
        [disabled]="currentPage === totalPages"
      >
        <nb-icon icon="arrow-forward-outline"></nb-icon>
      </button>
    </div>
  </ng-container>

  <ng-container *ngFor="let assignment of list">
    <!-- Archived Card (with tooltip) -->
    <nb-card
      *ngIf="assignment.isArchive === 1"
      class="assingment-card {{ isExpand ? 'w-50 ml-auto mr-auto' : '' }} {{
        assignment?.status?.toLowerCase() !== 'pending' ? 'cursor-pointer' : ''
      }}"
      [class.disabled-card]="true"
      [nbTooltip]="'This assignment has been archived by your teacher and is no longer active.'"
      [nbTooltipStatus]="'info'"
      nbTooltipTrigger="hover"
      (click)="
        assignment.isArchive !== 1 && assignment?.status?.toLowerCase() !== 'pending'
          ? viewAssignmentEvaluation(assignment?.assignment_evaluation, assignment, assignment?.status)
          : null
      "
    >
      <!-- shared content -->
      <ng-container *ngTemplateOutlet="cardContent; context: { $implicit: assignment }"></ng-container>
    </nb-card>

    <!-- Active Card (no tooltip) -->
    <nb-card
      *ngIf="assignment.isArchive !== 1"
      class="assingment-card {{ isExpand ? 'w-50 ml-auto mr-auto' : '' }} {{
        assignment?.status?.toLowerCase() !== 'pending' ? 'cursor-pointer' : ''
      }}"
      [class.disabled-card]="false"
      (click)="
        assignment?.status?.toLowerCase() !== 'pending'
          ? viewAssignmentEvaluation(assignment?.assignment_evaluation, assignment, assignment?.status)
          : null
      "
    >
      <!-- shared content -->
      <ng-container *ngTemplateOutlet="cardContent; context: { $implicit: assignment }"></ng-container>
    </nb-card>
  </ng-container>

  <!-- Template for card content -->
  <ng-template #cardContent let-assignment>
    <!-- Reuse the exact header/body sections you've already written -->
    <!-- web view -->
    <nb-card-header class="assignment-card" *ngIf="!isMobileScreen">
      <div class="d-flex" style="align-items: center">
        <div class="">
          <div class="document-img-background">
            <img
              src="/assets/icons/document.svg"
              class="cursor-pointer svg-dark-icon"
              alt="document-img"
              height="30"
              width="30"
              style="position: relative; top: 7px; left: 6px"
            />
          </div>
        </div>
        <div class="px-0 ml-1">
          <label
            class="text-uppercase quicksand-bold-label assignment-subject"
            [ngClass]="{
              'ml-1': storageService.detectMob()
            }"
          >
            {{ assignment?.subject?.subject | titlecase }}
          </label>
        </div>
        <div class="quicksand-normal-label start-time-content ml-auto px-0">
          Added on : {{ assignment.open_time | date : 'M/d/yy, h:mm a' }}
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 assignment-title quicksand-normal-label">
          {{ assignment.title | titlecase }}
        </div>
      </div>
      <div class="d-flex justify-content-between flex-wrap">
        <div class="row due-date mr-1">
          <div>
            <img src="/assets/icons/timer.svg" class="cursor-pointer" alt="timer-img" height="18" width="18" />
          </div>
          <div class="quicksand-normal-label end-time-content" style="margin-left: 12px">
            Due Date:
            {{ assignment.close_time | date : 'M/d/yy, h:mm a' }}
          </div>
        </div>

        <button
          nbButton
          class="quicksand-bold-label text-capitalize save-btn"
          (click)="openFeedbackModal($event,assignment?.studentAssignmentStatus?.[0]?.feedback)"
          *ngIf="assignment?.studentAssignmentStatus?.[0]?.completed === true && assignment?.studentAssignmentStatus?.[0]?.feedback"
        >
          View Feedback
        </button>
      </div>
    </nb-card-header>
    <nb-card-body
      *ngIf="!isMobileScreen"
      class="assignment-status"
      [ngClass]="!currentUser && assignment?.status?.toLowerCase() === 'pending' ? 'p-0' : ''"
      [ngStyle]="{
        'background-color':
          assignment?.status?.toLowerCase() === 'pending' || assignment?.status?.toLowerCase() === 'missed'
            ? '#ffe6e6'
            : '#eaf8ed'
      }"
    >
      <div class="quicksand-bold-label">
        <button
          nbButton
          *ngIf="!currentUser && assignment?.status?.toLowerCase() === 'pending'"
          class="btn-take-assignment quicksand-bold-label w-100 start-btn-assignment"
          (click)="takeAssignment(assignment?.id)"
        >
          START
        </button>

        <div
          *ngIf="!currentUser"
          class=" quicksand-bold-label {{
            assignment?.status?.toLowerCase() !== 'pending' && assignment?.status?.toLowerCase() !== 'missed'
              ? 'completed'
              : 'text-danger'
          }}"
        >
          {{
            assignment?.status?.toLowerCase() === 'missed'
              ? 'MISSED'
              : assignment?.status?.toLowerCase() !== 'pending'
              ? 'COMPLETED'
              : ''
          }}
        </div>

        <div
          *ngIf="currentUser"
          class=" quicksand-bold-label {{
            assignment?.status?.toLowerCase() === 'pending' || assignment?.status?.toLowerCase() === 'missed'
              ? 'pending'
              : 'completed'
          }}"
        >
          {{
            assignment?.status?.toLowerCase() === 'missed'
              ? 'MISSED'
              : assignment?.status?.toLowerCase() !== 'pending'
              ? 'COMPLETED'
              : 'PENDING'
          }}
        </div>
      </div>
    </nb-card-body>

    <!-- mobile-view -->
    <nb-card-header class="assignment-card" *ngIf="isMobileScreen">
      <div class="quicksand-normal-label start-time-content ml-auto px-0">
        Added on : {{ assignment.open_time | date : 'M/d/yy, h:mm a' }}
      </div>
      <div class="d-flex" style="align-items: center">
        <div class="">
          <div class="document-img-background">
            <img
              src="/assets/icons/document.svg"
              class="cursor-pointer"
              alt="document-img"
              height="20"
              width="20"
              style="position: relative; top: 2px; left: 6px"
            />
          </div>
        </div>
        <div class="px-0 ml-1">
          <label
            class="text-uppercase quicksand-bold-label assignment-subject subject-card-view"
            [ngClass]="{
              'ml-1': storageService.detectMob()
            }"
          >
            {{ assignment?.subject?.subject | titlecase }}
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 assignment-title quicksand-normal-label">
          {{ assignment.title | titlecase }}
        </div>
      </div>
      <div class="d-flex justify-content-between flex-wrap">
        <div class="row due-date mr-1">
          <div>
            <img src="/assets/icons/timer.svg" class="cursor-pointer" alt="timer-img" height="18" width="18" />
          </div>
          <div class="quicksand-normal-label end-time-content" style="margin-left: 7px">
            Due Date:
            {{ assignment.close_time | date : 'M/d/yy, h:mm a' }}
          </div>
        </div>
        <button
          nbButton
          class="quicksand-bold-label text-capitalize save-btn"
          (click)="openFeedbackModal($event,assignment?.studentAssignmentStatus?.[0]?.feedback)"
          *ngIf="assignment?.studentAssignmentStatus?.[0]?.completed === true && assignment?.studentAssignmentStatus?.[0]?.feedback"
        >
          View Feedback
        </button>
      </div>
    </nb-card-header>
    <nb-card-body
      *ngIf="isMobileScreen"
      class="assignment-status"
      [ngClass]="!currentUser && assignment?.status?.toLowerCase() === 'pending' ? 'p-0' : ''"
      [ngStyle]="{
        'background-color':
          assignment?.status?.toLowerCase() === 'pending' || assignment?.status?.toLowerCase() === 'missed'
            ? '#ffe6e6'
            : '#eaf8ed'
      }"
    >
      <div class="quicksand-bold-label">
        <button
          nbButton
          *ngIf="!currentUser && assignment?.status?.toLowerCase() === 'pending'"
          class="btn-take-assignment quicksand-bold-label w-100"
          (click)="takeAssignment(assignment?.id)"
        >
          START
        </button>

        <div
          *ngIf="!currentUser"
          class=" quicksand-bold-label {{
            assignment?.status?.toLowerCase() !== 'pending' && assignment?.status?.toLowerCase() !== 'missed'
              ? 'completed'
              : 'text-danger'
          }}"
        >
          {{
            assignment?.status?.toLowerCase() === 'missed'
              ? 'MISSED'
              : assignment?.status?.toLowerCase() !== 'pending'
              ? 'COMPLETED'
              : ''
          }}
        </div>

        <div
          *ngIf="currentUser"
          class=" quicksand-bold-label {{
            assignment?.status?.toLowerCase() === 'pending' || assignment?.status?.toLowerCase() === 'missed'
              ? 'pending'
              : 'completed'
          }}"
        >
          {{
            assignment?.status?.toLowerCase() === 'missed'
              ? 'MISSED'
              : assignment?.status?.toLowerCase() !== 'pending'
              ? 'COMPLETED'
              : ''
          }}
        </div>
      </div>
    </nb-card-body>
  </ng-template>

  <div
    class="no-assignments-found no-assignments-found-padding quicksand-bold-label m-auto text-center"
    *ngIf="list && list.length === 0"
  >
    <div class="parent">
      <img src="/assets/icons/no-assignment-one.svg" class="image1 img-fluid" alt="no-assignment-found" />
      <img src="/assets/icons/no-assignment-two.svg" class="image2 img-fluid" alt="no-assignment-found" />
      <img src="/assets/icons/no-assignment-three.svg" class="image3 img-fluid" alt="no-assignment-found" />
    </div>
    <div class="mt-5">No Assignments Found</div>
  </div>
</ng-template>

<ng-template #myModal let-modal>
  <div
    class="add-classroom-modal"
    [ngClass]="{
      'dark-theme': alayticsService.currentTheme === 'material-dark'
    }"
  >
    <div class="modal-header d-flex justify-content-between align-items-center w-100">
      <div class="d-flex">
        <span class="icon-add-classroom">
          <nb-icon icon="plus-outline"></nb-icon>
        </span>
        <h6 class="modal-title add-clasroom-text quicksand-bold-label">Assignment Feedback</h6>
      </div>
      <div>
        <span class="icon-close-classroom-modal d-block cursor-pointer" (click)="modalService.dismissAll(modalRef)">
          <nb-icon icon="close-outline" class="text-dark icon-close icon-close-dark-mode"></nb-icon>
        </span>
      </div>
    </div>

    <div class="modal-body">
      <textarea
        nbInput
        fullWidth
        [ngModel]="feedback"
        placeholder="Add project title"
        readonly
        class="feedback-textarea auto-resize-textarea nb-input quicksand-normal-label bg-transparent border-0"
      ></textarea>
    </div>
  </div>
</ng-template>
